import { Link } from "react-router-dom";
import { Linkedin, Mail, Phone, MapPin } from "lucide-react";
import { CONTACT_EMAIL, PHONE, LINKEDIN_URL } from "../../content";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-gold/30 bg-cream">
    <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-3 lg:px-10">
      <div>
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center border border-golddeep/60 font-serif text-lg font-bold text-golddeep">
            RB
          </span>
          <div>
            <p className="font-serif text-lg font-semibold text-ink">Roy Buncome</p>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-golddeep">
              CollabIgnite
            </p>
          </div>
        </div>
        <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-600">
          Strategy Architect. Capital raise wingman. CollabIgnite connects people,
          strategy, technology, resources, and opportunity. Collaboration ignited.
          Growth accelerated.
        </p>
      </div>

      <div>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-golddeep">Navigate</p>
        <div className="mt-5 flex flex-col gap-3 text-sm">
          <Link data-testid="footer-home-link" to="/" className="text-slate-600 transition-colors hover:text-golddeep">Home</Link>
          <Link data-testid="footer-about-link" to="/about" className="text-slate-600 transition-colors hover:text-golddeep">About Roy</Link>
          <Link data-testid="footer-working-link" to="/working-with-me" className="text-slate-600 transition-colors hover:text-golddeep">Working With Me</Link>
          <Link data-testid="footer-creatives-link" to="/creatives" className="text-slate-600 transition-colors hover:text-golddeep">Creative Growth</Link>
          <Link data-testid="footer-book-link" to="/book" className="text-slate-600 transition-colors hover:text-golddeep">Conversations with Roy</Link>
          <Link data-testid="footer-contact-link" to="/contact" className="text-slate-600 transition-colors hover:text-golddeep">Contact</Link>
        </div>
      </div>

      <div>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-golddeep">Direct</p>
        <div className="mt-5 flex flex-col gap-3 text-sm text-slate-600">
          <a
            data-testid="footer-email-link"
            href={`mailto:${CONTACT_EMAIL}`}
            className="flex items-center gap-2.5 transition-colors hover:text-golddeep"
          >
            <Mail size={15} className="text-golddeep" /> {CONTACT_EMAIL}
          </a>
          <a
            data-testid="footer-phone-link"
            href="tel:+19044109000"
            className="flex items-center gap-2.5 transition-colors hover:text-golddeep"
          >
            <Phone size={15} className="text-golddeep" /> {PHONE}
          </a>
          <a
            data-testid="footer-linkedin-link"
            href={LINKEDIN_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2.5 transition-colors hover:text-golddeep"
          >
            <Linkedin size={15} className="text-golddeep" /> linkedin.com/in/roybuncome
          </a>
          <span className="flex items-center gap-2.5 text-slate-500">
            <MapPin size={15} className="text-golddeep" /> Jacksonville, Florida
          </span>
        </div>
      </div>
    </div>
    <div className="border-t border-gold/25 py-5 text-center font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">
      © {new Date().getFullYear()} CollabIgnite · Make it. Protect it. Do good, together.
    </div>
  </footer>
);
